@if(service.viewDroplistItems.length){
<div class='admissions-commitments-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'> </droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Commitments) {
	<admissions-commitments-view-part></admissions-commitments-view-part>
	}
	}
	}
</div>
}